const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
interface TNiceBytesArgs {
	bytes: number;
	decimalNumber?: number;
	addSpace?: boolean;
}
export const niceBytes = ({
	bytes,
	addSpace,
	decimalNumber,
}: TNiceBytesArgs) => {
	let position = 0;
	let number = parseInt(`${bytes}`, 10) || 0;
	const space = addSpace ? ' ' : '';

	while (number >= 1024 && ++position) {
		number /= 1024;
	}

	return `${number.toFixed(
		decimalNumber ?? (number < 10 && position > 0 ? 1 : 0),
	)}${space}${units[position]}`;
};
